import { USER_SESSION_SEARCH } from './action_types';

const search = payload => ({
  type: USER_SESSION_SEARCH,
  payload: payload
});

export { search };
